import { useState, useCallback, useEffect } from 'react';
import Drawer from '~/components/Drawer';
import { inputStyles } from '~/components/Vendors/styles';
import { FinancialCoordinatorOption } from '~/types/fundrequests';

interface Props {
    isOpen: boolean;
    setIsOpen: any;
    financial_coordinators: FinancialCoordinatorOption[];
    handleSaveFinancialCoordinator: (fc: FinancialCoordinatorOption) => void;
    saving: boolean;
}

const AssignFinancialCoordinatorDrawer: React.FC<Props> = ({
    isOpen,
    setIsOpen,
    financial_coordinators,
    handleSaveFinancialCoordinator,
    saving,
}) => {
    const [selectedFc, setSelectedFc] =
        useState<FinancialCoordinatorOption | null>(null);

    const resetAndCloseForm = () => {
        setIsOpen(false);
    };

    return (
        <Drawer isOpen={isOpen} setIsOpen={setIsOpen}>
            <h2 className='mb-[28px] text-[22px]/[28px] font-bold'>
                Assign Financial Coordinator
            </h2>

            <label
                htmlFor='mid-primary-medical-reason'
                className='block font-bold'
            >
                Financial Coordinator <span className='text-red'>*</span>
            </label>
            <select
                className={`${inputStyles} bg-grey w-full`}
                onChange={(e) => {
                    setSelectedFc(
                        financial_coordinators?.find(
                            (fc) => fc.id === parseInt(e.target.value)
                        ) || null
                    );
                }}
            >
                <option value=''>Select</option>
                {financial_coordinators?.map((fc) => (
                    <option
                        key={`${fc.first_name} ${fc.last_name}`}
                        value={fc.id}
                    >
                        {fc.first_name} {fc.last_name}
                    </option>
                ))}
            </select>

            <div className='mt-[30px]'>
                <button
                    className='m-auto mr-3 justify-self-end rounded-3xl border-[2px] border-black bg-white px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase hover:bg-black hover:text-white'
                    onClick={resetAndCloseForm}
                >
                    Cancel
                </button>
                <button
                    className='m-auto mr-3 rounded-full bg-[#FEBF3E] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase text-[#131212] hover:bg-opacity-90'
                    onClick={() => {
                        if (selectedFc) {
                            handleSaveFinancialCoordinator(selectedFc);
                            resetAndCloseForm();
                        }
                    }}
                    disabled={!selectedFc || saving}
                >
                    {saving ? 'Saving...' : 'Save'}
                </button>
            </div>
        </Drawer>
    );
};

export default AssignFinancialCoordinatorDrawer;
